export const FontSizeController = {
    init: function () {
        this.cacheSelectors();
        if (this.validateSelectors()) {
            this.setInitialFontSizes();
            this.bindEvents();
            this.maxAdjustments = 3;
            this.increaseCount = 0;
            this.decreaseCount = 0;
            this.updateFontSize();
        }
    },

    cacheSelectors: function () {
        this.title = document.getElementById('title');
        this.content = document.getElementById('postContent');
        this.btnIncreaseFont = document.getElementById('increaseFont');
        this.btnDecreaseFont = document.getElementById('decreaseFont');
        this.btnResetFont = document.getElementById('resetFont');
    },

    validateSelectors: function () {
        if (!this.title || !this.content || !this.btnIncreaseFont || !this.btnDecreaseFont || !this.btnResetFont) {
            return false;
        }
        return true;
    },

    setInitialFontSizes: function () {
        this.baseFontSizeTitle = parseInt(window.getComputedStyle(this.title).fontSize, 10) || 16;
        this.baseFontSizesContent = Array.from(this.content.children).map(child =>
            parseInt(window.getComputedStyle(child).fontSize, 10) || 16
        );
    },

    bindEvents: function () {
        this.btnIncreaseFont.addEventListener('click', this.increaseFont.bind(this));
        this.btnDecreaseFont.addEventListener('click', this.decreaseFont.bind(this));
        this.btnResetFont.addEventListener('click', this.resetFont.bind(this));
    },

    updateFontSize: function () {
        // Atualiza o tamanho do título
        this.title.style.fontSize = `${this.baseFontSizeTitle}px`;

        // Atualiza o tamanho de cada elemento dentro de #postContent
        Array.from(this.content.children).forEach((child, index) => {
            child.style.fontSize = `${this.baseFontSizesContent[index]}px`;
        });
    },

    increaseFont: function () {
        if (this.increaseCount < this.maxAdjustments) {
            this.baseFontSizeTitle += 2;
            this.baseFontSizesContent = this.baseFontSizesContent.map(size => size + 2);
            this.increaseCount++;
            this.decreaseCount = Math.max(this.decreaseCount - 1, 0);
            this.updateFontSize();
        }
    },

    decreaseFont: function () {
        if (this.decreaseCount < this.maxAdjustments) {
            this.baseFontSizeTitle -= 2;
            this.baseFontSizesContent = this.baseFontSizesContent.map(size => size - 2);
            this.decreaseCount++;
            this.increaseCount = Math.max(this.increaseCount - 1, 0);
            this.updateFontSize();
        }
    },

    resetFont: function () {
        this.setInitialFontSizes();
        this.increaseCount = 0;
        this.decreaseCount = 0;
        this.updateFontSize();
    },
};

// Inicializa o controlador de tamanhos de fonte
document.addEventListener('DOMContentLoaded', () => {
    FontSizeController.init();
});
